export enum EnumTarja {
    VendaLivre = 0,
    TarjaVermelha = 1,
    TarjaPreta = 2
}